window.addEventListener('load', () => {
    const menuItemsWithChilds = document.querySelectorAll('.menu-item-has-children')
    console.log(`found some menus`, menuItemsWithChilds);
    menuItemsWithChilds.forEach((item, idx, all) => {

        // get a list of all other menus to close them
        const rest = [...all].filter((_, id)=> id != idx)
        const closeAllOthers = () => 
            rest.forEach(other => other.classList.remove('menu-item-open'))

        // add event handler to open and close the clicked item
        item.addEventListener('click', () => {
            closeAllOthers()
            const isOpen = item.classList.contains('menu-item-open')
            if (isOpen) {
                item.classList.remove('menu-item-open')
            } else {
                item.classList.add('menu-item-open')
            }
        })
        let closeTimeout = undefined
        item.addEventListener('mouseover', () => {
            closeTimeout && clearTimeout(closeTimeout)
            closeTimeout = undefined

            closeAllOthers()
            const isOpen = item.classList.contains('menu-item-open')
            if (!isOpen) {
                item.classList.add('menu-item-open')
            }
        })
        item.addEventListener('mouseout', () => {
            closeAllOthers()
            const isOpen = item.classList.contains('menu-item-open')
            if (isOpen) {
                closeTimeout = setTimeout(
                    () => item.classList.remove('menu-item-open'),
                    175
                )
            }
        })
    })
})